import { __assign } from "tslib";
import { CoherenceTheme } from '@cseo/styles';
import { FontWeights, mergeStyleSets, Text } from '@fluentui/react';
import React from 'react';
var badgeBase = {
    position: 'absolute',
    height: '16px',
    minWidth: '16px',
    borderRadius: '8px',
    fontSize: '10px',
    fontWeight: FontWeights.semibold,
    lineHeight: 16,
    textAlign: 'center',
    paddingLeft: '3px',
    paddingRight: '3px',
    backgroundColor: CoherenceTheme.palette.themeDarker,
    color: CoherenceTheme.palette.white,
    top: '-16px'
};
var Styles = mergeStyleSets({
    badgeContainer: {
        position: 'relative'
    },
    badgeSingleDigit: __assign(__assign({}, badgeBase), { minWidth: '10px', right: '-4px' }),
    badgeDoubleDigits: __assign(__assign({}, badgeBase), { right: '-8px' }),
    badgeTripleDigits: __assign(__assign({}, badgeBase), { right: '-10px' })
});
export function NotificationControl(newItemCount, isPanelOpen, onClickFunction, title, ariaLabel) {
    var ariaLabelText = (newItemCount > 0 && newItemCount <= 99) ? newItemCount + " new notification" + (newItemCount !== 1 ? 's' : '') : (newItemCount > 0 ? 'Over 99 new notifications' : 'Notifications');
    return {
        key: 'notifications',
        text: title || 'Notifications',
        value: 'Notifications',
        title: title || 'Notifications',
        ariaLabel: ariaLabel || ariaLabelText,
        checked: isPanelOpen,
        iconProps: {
            iconName: 'Ringer'
        },
        onClick: onClickFunction,
        onRenderIcon: function (props, defaultRender) {
            var badge = (newItemCount < 10)
                ? Styles.badgeSingleDigit
                : (newItemCount < 100)
                    ? Styles.badgeDoubleDigits
                    : Styles.badgeTripleDigits;
            return (React.createElement(React.Fragment, null,
                defaultRender(props),
                newItemCount > 0 &&
                    React.createElement("div", { className: Styles.badgeContainer },
                        React.createElement(Text, { className: [badge, 'notification-badge'].join(' ') }, newItemCount <= 99 ? newItemCount : '99+'))));
        }
    };
}
//# sourceMappingURL=NotificationControl.js.map